import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const getAllDsos = {
  name: 'getAllDsos',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    getReceived(state, payload) {
      const { rows = [], count = 0 } = payload.data;
      const dsoData = rows.map((item) => ({
        id: item.id,
        name: item.name,
        ownerName: item.owner_name,
        email: item.email,
        displayCount: item.displays,
        planId: item.planid,
        planName: item.plan_name,
      }));

      return {
        ...state,
        data: dsoData,
        loading: false,
        error: '',
        totalCount: Number(count) || dsoData.length,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async allDsos() {
      try {
        const url = `savvy/organization/get-dsos-lookup`;
        this.getRequested();
        const response = await http.get(url);
        if (response?.data?.data) {
          this.getReceived({
            data: response.data.data,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default getAllDsos;
